import { createSubscriptionsColumnDefinitions } from "../SubscriptionTableColumns";

const subscriptionsColumnDefinitions = createSubscriptionsColumnDefinitions();

export const SUBSCRIPTIONS_FIXED_COLUMNS = Object.keys(
  subscriptionsColumnDefinitions
).slice(0, 2);

export const DEFAULT_SUBSCRIPTIONS_VISIBLE_COLUMNS = Object.keys(
  subscriptionsColumnDefinitions
).filter((key) => !SUBSCRIPTIONS_FIXED_COLUMNS.includes(key));

export const subscriptionsColumnOptions = Object.values(
  subscriptionsColumnDefinitions
)
  .filter(({ key }) => !SUBSCRIPTIONS_FIXED_COLUMNS.includes(key))
  .map(({ key, label }) => ({ text: label, value: key }));
